import React from "react";
import ListMarket from "./components/ListMarket";

const App = () => {
  return (
    <div>
      <ListMarket />
    </div>
  );
};

export default App;
